export const isString = (data: any) => typeof data  === 'string';

// New classes are assigned a string classId on the frontend via uniqId() and only
// receive a numeric id from the backend once saved. A string classId therefore means
// the class has not yet been persisted.
export const isTemporaryClassId = (classId: string | number | undefined | null): boolean =>
    typeof classId === 'string';

export const leadZero = (num: number) => (num < 10 ? '0' : '') + num;

export const toBoolean = (data: any) => {
    if (typeof data === 'string') {
        data = data === 'true';
    }

    if (typeof data === 'number') {
        data = Boolean(data);
    }

    return data;
};

export const openInNewTab = (url: string) => {
    url && window.open(url, '_blank');
}
